import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const PREFIX = 'CompanyForm';

export const classes = {
  marginBottom: `${PREFIX}-marginBottom`,
  marginBottomCurrency: 'CurrencyList-marginBottom',
};

export const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.marginBottom}`]: {
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.marginBottomCurrency}`]: {
    marginBottom: theme.spacing(2),
    padding: `${theme.spacing(1)} ${theme.spacing(0)} !important`,
  },
}));

export const StyledGridDatePicker = styled(Grid)(({ theme }) => ({
  '&.MuiGrid-root': {
    '& .MuiInputLabel-root': {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left',
      margin: '0px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderBottom: '1px solid grey',
    },
    '& .MuiOutlinedInput-input': {
      padding: '4px 0px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '0px',
      marginTop: '16px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        borderBottom: '1px solid grey',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        borderBottom: '1px solid grey',
      },
    },
  },
}));
